(() => {
  const popup = document.querySelector('[data-ww-lead-popup]');
  const leadForms = document.querySelectorAll('[data-ww-lead-capture] form');
  const now = Date.now();
  const day = 86400000;
  const convertedAt = Number(localStorage.getItem('wwLeadConvertedAt') || 0);
  const dismissedAt = Number(localStorage.getItem('wwLeadDismissedAt') || 0);
  const success = document.querySelector('[data-ww-lead-success]');

  if (success) {
    localStorage.setItem('wwLeadConvertedAt', String(now));
    requestAnimationFrame(() => success.focus());
  }

  leadForms.forEach((form) => {
    form.addEventListener('submit', () => {
      localStorage.setItem('wwLeadConvertedAt', String(Date.now()));
    });
  });

  document.querySelectorAll('[data-ww-print-guide]').forEach((button) => {
    button.addEventListener('click', () => window.print());
  });

  if (!popup || success || (convertedAt && now - convertedAt < 180 * day) || (dismissedAt && now - dismissedAt < 7 * day)) return;

  let shown = false;
  let lastFocused = null;
  let scrollTriggered = false;

  const showPopup = () => {
    if (shown) return;
    shown = true;
    lastFocused = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('ww-lead-popup-open');
    const dialog = popup.querySelector('[role="dialog"]');
    requestAnimationFrame(() => dialog && dialog.focus());
  };

  const closePopup = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('ww-lead-popup-open');
    localStorage.setItem('wwLeadDismissedAt', String(Date.now()));
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  popup.querySelectorAll('[data-ww-lead-close]').forEach((button) => button.addEventListener('click', closePopup));
  document.addEventListener('keydown', (event) => {
    if (!popup.hidden && event.key === 'Escape') closePopup();
  });

  let articleViews = Number(sessionStorage.getItem('wwArticleViews') || 0) + 1;
  sessionStorage.setItem('wwArticleViews', String(articleViews));
  window.setTimeout(showPopup, articleViews >= 2 ? 15000 : 60000);

  const onScroll = () => {
    if (scrollTriggered) return;
    const root = document.documentElement;
    const available = Math.max(1, root.scrollHeight - window.innerHeight);
    if (window.scrollY / available >= 0.55) {
      scrollTriggered = true;
      showPopup();
      window.removeEventListener('scroll', onScroll);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia('(min-width: 990px)').matches) {
    document.addEventListener('mouseout', (event) => {
      if (!event.relatedTarget && event.clientY <= 8) showPopup();
    });
  }
})();